'use client';

import { TBlogModuleCenter } from '@/app/(blogposts)/blog/blog.types';
import { Button } from '@/components/ui/Button';
import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { BlogArticleModuleCentersCardDesktop } from '../BlogArticleModuleCentersCardDesktop';

import './BlogArticleModuleCentersDesktop.scss';

type Props = {
  module: TBlogModuleCenter;
};

export const BlogArticleModuleCentersDesktop: React.FC<Props> = ({
  module: { title, subtitle, locations, textColor },
}) => {
  const [selectedLocationId, setSelectedLocationId] = useState<
    undefined | string
  >(undefined);

  const handleSelect = useCallback(
    (locationId: string) => setSelectedLocationId(locationId || undefined),
    []
  );

  const handleUnselect = useCallback(
    () => setSelectedLocationId(undefined),
    []
  );

  return (
    <div className='BlogArticleModuleCentersDesktop'>
      <Typography
        className='BlogArticleModuleCentersDesktop__title'
        variant='h3'
      >
        {title}
      </Typography>

      <Typography
        className='BlogArticleModuleCentersDesktop__subtitle'
        variant='body-small'
      >
        {subtitle}
      </Typography>

      <Typography
        className='BlogArticleModuleCentersDesktop__locations'
        variant='h3-serif'
      >
        Our Locations:
      </Typography>

      <div
        className={clsx('BlogArticleModuleCentersDesktop__cards', {
          'BlogArticleModuleCentersDesktop__cards--focused':
            selectedLocationId !== undefined,
        })}
      >
        {locations.map(({ item: location }) => (
          <BlogArticleModuleCentersCardDesktop
            className={clsx('BlogArticleModuleCentersDesktop__card', {
              'BlogArticleModuleCentersDesktop__card--hidden':
                Boolean(selectedLocationId) &&
                selectedLocationId !== location.id.toString(),
            })}
            location={location}
            key={location.id}
            onClick={
              selectedLocationId === location.id.toString()
                ? handleUnselect
                : () => handleSelect(location.id.toString())
            }
            focused={selectedLocationId === location.id.toString()}
            textColor={textColor}
          />
        ))}
      </div>

      <Button
        className='BlogArticleModuleCentersDesktop__call-to-action'
        href='/sign-up'
        variant='dark'
      >
        Join Now
      </Button>
    </div>
  );
};
